import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CookieStorage } from './storage/cookie-storage';
import { ConfigStorage } from './storage/config-storage';
import { validateExternalApi } from './lib/utils';
export class SecondaryBsiManager {
  constructor() {
    _defineProperty(this, "api", void 0);
    _defineProperty(this, "options", void 0);
    _defineProperty(this, "cookie", void 0);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "acitivityListeners", []);
    _defineProperty(this, "timeout", void 0);
    _defineProperty(this, "initialized", false);
  }
  static create(api, options) {
    return new SecondaryBsiManager().init(api, options);
  }
  extendSession() {
    if (!this.options.enableCookie) {
      return;
    }
    const {
      ttl
    } = this.cookie.set(this.config.get());
    clearTimeout(this.timeout);
    if (ttl) {
      // Keep the cookie alive until a new bsi value is set on the common config in master
      this.timeout = setTimeout(() => this.extendSession(), ttl - 1000);
    }
  }
  getSessionAndNotify() {
    // Notify listeners
    this.acitivityListeners.forEach(listener => listener());
    return this.get();
  }
  get() {
    return this.options.enableCookie ? this.config.get() || this.cookie.get() : this.config.get();
  }
  init(api, options) {
    validateExternalApi(api, 'getCommonConfig');
    this.api = api;
    this.options = options;
    this.config = new ConfigStorage(this.api.getCommonConfig, this.api.getConsentPolicy).subscribe(() => this.extendSession());
    this.cookie = new CookieStorage(this.config, this.api.getCookieReaderWriter);
    this.initialized = true;
    this.extendSession();
    return this;
  }
  destroy() {
    clearTimeout(this.timeout);
  }
  onActivity(listener) {
    if (typeof listener !== 'function') {
      throw new Error(`bsiManager: listener must be a function`);
    }
    this.acitivityListeners.push(listener);
    return this;
  }
  getBsi(_temp) {
    let {
      extend
    } = _temp === void 0 ? {
      extend: true
    } : _temp;
    if (!this.initialized) {
      throw new Error('bsiManager: please call init() first');
    }
    if (extend) {
      return this.getSessionAndNotify();
    }
    return this.get();
  }
}
//# sourceMappingURL=manager-secondary.js.map